"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResource = void 0;
const react_1 = require("react");
const rxjs_1 = require("rxjs");
const trade_1 = require("@tencent/tccp-frontend-contract/trade");
const useFetch_1 = require("../_hooks/useFetch");
const useStatic_1 = require("../_hooks/useStatic");
const useSubject_1 = require("../_hooks/useSubject");
const validator_1 = require("../modules/validator");
function useResource(spuCode, scene, { fetchSpuTreeNode, fetchSpuSceneAssets }) {
    const emptyObject = (0, useStatic_1.useEmptyObject)();
    const emptyArray = (0, useStatic_1.useEmptyArray)();
    // 异步拉取配置
    const spuTreeNode$ = (0, useFetch_1.useFetchWithSpuCode)(spuCode, fetchSpuTreeNode, emptyObject);
    const spuSceneAssets$ = (0, useFetch_1.useFetchWithSpuScene)(spuCode, scene, fetchSpuSceneAssets, emptyObject);
    const externalParameterList_ = (0, react_1.useMemo)(() => spuSceneAssets$.pipe((0, rxjs_1.map)(({ ExternalParameterList = [] }) => ExternalParameterList)), [spuSceneAssets$]);
    const strategyList_ = (0, react_1.useMemo)(() => spuSceneAssets$.pipe((0, rxjs_1.map)(({ StrategyList = [] }) => {
        const result = {
            [trade_1.StrategyGroupEnum.Factory]: [],
            [trade_1.StrategyGroupEnum.Constraint]: [],
            [trade_1.StrategyGroupEnum.Buy]: [],
            [trade_1.StrategyGroupEnum.GlobalConstraint]: [],
            [trade_1.StrategyGroupEnum.ParamSet]: [],
        };
        for (const StrategyGroup of StrategyList) {
            if (StrategyGroup.Group === trade_1.StrategyGroupEnum.Factory) {
                result[trade_1.StrategyGroupEnum.Factory] = StrategyGroup.StrategyList;
            }
            else if (StrategyGroup.Group === trade_1.StrategyGroupEnum.Constraint) {
                result[trade_1.StrategyGroupEnum.Constraint] =
                    StrategyGroup.StrategyList;
            }
            else if (StrategyGroup.Group === trade_1.StrategyGroupEnum.Buy) {
                result[trade_1.StrategyGroupEnum.Buy] = StrategyGroup.StrategyList;
            }
            else if (StrategyGroup.Group === trade_1.StrategyGroupEnum.GlobalConstraint) {
                result[trade_1.StrategyGroupEnum.GlobalConstraint] =
                    StrategyGroup.StrategyList;
            }
            else if (StrategyGroup.Group === trade_1.StrategyGroupEnum.ParamSet) {
                result[trade_1.StrategyGroupEnum.ParamSet] = StrategyGroup.StrategyList;
            }
        }
        return result;
    })), [spuSceneAssets$]);
    const loaded_ = (0, react_1.useMemo)(
    // 不要默认初始值
    () => (0, rxjs_1.combineLatest)([
        spuTreeNode$.pipe((0, rxjs_1.skipWhile)(spuTreeNode => !spuTreeNode.Spu)),
        spuSceneAssets$.pipe((0, rxjs_1.skipWhile)(({ ExternalParameterList = [], StrategyList = [] }) => !ExternalParameterList.length && !StrategyList.length)),
    ]).pipe((0, rxjs_1.switchMap)(() => rxjs_1.EMPTY.pipe((0, rxjs_1.startWith)(true)))), [spuTreeNode$, spuSceneAssets$]);
    const spuMeta_ = (0, react_1.useMemo)(() => spuTreeNode$.pipe((0, rxjs_1.map)(spuTreeNode => spuTreeNode.Spu), (0, rxjs_1.filter)((spu) => !!spu)), [spuTreeNode$]);
    const spuMeta = (0, useSubject_1.useStateWithObservable)(spuMeta_, emptyObject);
    const paramList_ = (0, react_1.useMemo)(() => (0, rxjs_1.combineLatest)([spuTreeNode$, externalParameterList_, strategyList_]).pipe((0, rxjs_1.filter)(([spuTreeNode]) => !!spuTreeNode.Spu), (0, rxjs_1.map)(([spuTreeNode, externalParameterList, strategyList]) => {
        var _a, _b, _c;
        const paramList = trade_1.ClientParamList.fromSpuTree(spuTreeNode, externalParameterList);
        const uselessSpecParamList = (_c = (_b = (_a = strategyList[trade_1.StrategyGroupEnum.ParamSet]) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.Description.UselessSpecParamList.map(({ Key }) => Key)) !== null && _c !== void 0 ? _c : [];
        return paramList.filter(x => !uselessSpecParamList.includes(x.paramKey));
    })), [spuTreeNode$, externalParameterList_, strategyList_]);
    const paramList = (0, useSubject_1.useStateWithObservable)(paramList_, emptyArray);
    const validator_ = (0, react_1.useMemo)(() => (0, rxjs_1.combineLatest)([spuMeta_, paramList_, strategyList_]).pipe((0, rxjs_1.skipUntil)(loaded_), (0, rxjs_1.map)(([spuMeta, flatSpecNodeList, strategy]) => new validator_1.Validator(spuMeta.SpuCode, scene, flatSpecNodeList, strategy))), [loaded_, spuMeta_, scene, paramList_, strategyList_]);
    return {
        spuMeta_,
        paramList_,
        strategyList_,
        validator_,
        spuMeta,
        paramList,
        loaded_,
    };
}
exports.useResource = useResource;
